import { getSupportedLanguages, SupportedLanguage } from "@/api/languagesApi";
import { defaultLanguage } from "@/constants";
import { UserRole } from "@/uses/useUserRoles";
import { LANGUAGE_FOR_ROLE_REQUIRED_MESSAGE } from "@/utils/validationMessages";
import { onBeforeMount, ref, watch } from "vue";

const languageValidator = {
  language: [
    {
      required: true,
      message: LANGUAGE_FOR_ROLE_REQUIRED_MESSAGE,
      trigger: "change",
    },
  ],
};

export function useLanguage(form: Record<string, any>) {
  const languageList = ref<SupportedLanguage[]>([]);
  const languageDisabled = ref(true);

  const isSiteAdminOrClinician = (role: string) => role === UserRole.SiteAdmin || role === UserRole.Clinician;

  watch(
    () => form.role_ids,
    newRole => {
      if (newRole.length === 0) return;
      if (isSiteAdminOrClinician(newRole[0])) {
        languageDisabled.value = false;
        return;
      }
      languageDisabled.value = true;
      form.language = defaultLanguage;
    },
    { immediate: true }
  );

  onBeforeMount(async () => {
    try {
      languageList.value = await getSupportedLanguages();
    } catch (error) {
      console.error(error);
    }
  });

  return {
    languageList,
    languageDisabled,
    languageValidator,
  };
}
